import { render, staticRenderFns } from "./PreventRecurrenceProcedure.vue?vue&type=template&id=4ade057b&"
import script from "./PreventRecurrenceProcedure.vue?vue&type=script&lang=js&"
export * from "./PreventRecurrenceProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports